<div class="position-relative h-100 d-flex flex-column">
  <app-section-loader [loading]="loading"></app-section-loader>
  <div class="scroll page-bg flex-fill overflow-auto py-3 px-5 centerform">
    <div class="container p-0">
      <form [formGroup]="curriculumForm" (ngSubmit)="onSubmit()">
        <div class="mControls">
          <div class="input-group mr-auto">
            <h1 class="m-0 text-white align-items-center d-inline-flex">Edit Yearly Plan</h1>
          </div>
          <div class="mControls__right">
            <div class="input-group">
              <button type="button" mat-raised-button (click)="navigateBack()">Cancel</button>
            </div>
            <div class="input-group">
              <button type="submit" mat-raised-button color="primary">Done</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mb-3">
            <div class="card">
              <div class="card-header">General</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Name</mat-label>
                      <input maxlength="255" placeholder="Yearly Plan Name" matInput type="text" formControlName="curriculum_name" required>
                      <mat-error *ngIf="curriculumForm.get('curriculum_name').hasError('required')">Name is
                        required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-12 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Description</mat-label>
                      <textarea matInput rows="4" placeholder="Main description"
                        formControlName="description"></textarea>
                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-checkbox formControlName="is_finished">Mark as Finished</mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 mb-3">
            <div class="card">
              <div class="card-header d-flex align-items-center justify-content-between">
                <span>Lesson Plans</span>
                <div class="d-flex align-items-center">
                  <mat-form-field appearance="outline" class="mb-0 mr-2 no-error" style="width: 180px;">
                    <mat-label>Filter Grades</mat-label>
                    <mat-select multiple [(ngModel)]="selectedCurriculumGradeIds"
                      [ngModelOptions]="{standalone: true}"
                      (selectionChange)="filterCurriculumLessonPlans()">
                      <mat-option *ngFor="let grade of availableCurriculumGrades" [value]="grade.id">
                        {{ grade.grade_level }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="mb-0 mr-2 no-error"
                [class.mat-form-field-invalid]="duplicateLessonPlanError" style="width: clamp(280px, 32vw, 560px);">
                <mat-label>Select Lesson Plan</mat-label>

                <mat-select [(ngModel)]="selectedLessonPlanId" (selectionChange)="duplicateLessonPlanError = false"
                  panelClass="lesson-plan-select-panel">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="lessonPlanSearchControl"
                      [noEntriesFoundLabel]="'No matching lesson plan found'" placeholderLabel="Search lesson plan">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let lp of filteredLessonPlans" [value]="lp.id">
                    <span class="lesson-plan-option-text">
                      {{ lp.lesson_plan_number }} — {{ lp.grade_id?.grade_level }} — {{ lp.lesson_plan_name }}
                    </span>
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="duplicateLessonPlanError">
                  Lesson plan is already added to this Yearly Plan
                </mat-error>
              </mat-form-field>
                  <button type="button" mat-raised-button color="primary" [disabled]="!selectedLessonPlanId"
                    (click)="addLessonPlan()">
                    Add
                  </button>
                </div>
              </div>
              <div class="card-body p-0">
                <table *ngIf="lessonPlans?.length > 0" class="table no-wrap m-0 table--hover">
                  <thead>
                    <tr>
                  <th scope="col">Lesson Number</th>
                  <th scope="col">Lesson Name</th>
                  <th scope="col">Grade Level</th>
                  <th scope="col" class="table-head-empty-label">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let lpc of lessonPlans">
                  <td class="cursor-pointer" (click)="goToLessonPlan(lpc.lesson_plan_id?.id)">
                    {{ lpc.lesson_plan_id?.lesson_plan_number }}
                  </td>
                  <td class="cursor-pointer" (click)="goToLessonPlan(lpc.lesson_plan_id?.id)">
                    {{ lpc.lesson_plan_id?.lesson_plan_name }}
                  </td>
                  <td>{{ lpc.lesson_plan_id?.grade_id?.grade_level }}</td>
                  <td class="text-nowrap">
                    <a class="cursor-pointer icon-btn mr-2 d-inline-block"
                      (click)="editLessonPlan(lpc.lesson_plan_id?.id)" aria-label="Edit">
                      <mat-icon matTooltip="Edit lesson plan">edit</mat-icon>
                    </a>
                    <a class="cursor-pointer icon-btn d-inline-block" (click)="removeLessonPlan(lpc.id)"
                      aria-label="Remove">
                      <mat-icon matTooltip="Remove from Yearly Plan">delete</mat-icon>
                    </a>
                  </td>
                </tr>
                  </tbody>
                </table>
                <div *ngIf="!lessonPlans?.length" class="p-4 text-center text-muted">
                  No lesson plans added yet.
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
